/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable jsx-a11y/media-has-caption */
/* eslint-disable react/forbid-prop-types */
import React, { useEffect } from 'react';
import Head from 'next/head';
import PropTypes from 'prop-types';
import cx from 'clsx';
import useTranslation from 'next-translate/useTranslation';
import sidekick from '@last-rev/contentful-sidekick-util';
import { documentToHtmlString } from '@contentful/rich-text-html-renderer';
import ElementVideo, { ElementVideoPropTypes } from '../ElementVideo';
import RichTextParser from '../RichTextParser/RichTextParser';
import RichTextParserPropTypes from '../RichTextParser/RichTextParserPropTypes';
import ContentModule from '../ContentModule';
import styles from './PageVideo.module.scss';
import { useRouter } from 'next/router';
import { useState } from 'react';
import VideoCard from '../ModuleCard/VideoCard';
import Link from 'next/link';

export const PageVideoPropTypes = {
  _id: PropTypes.string.isRequired,
  _contentTypeId: PropTypes.string.isRequired,
  pageTitle: PropTypes.string.isRequired,
  video: PropTypes.shape(ElementVideoPropTypes).isRequired,
  videoTitle: PropTypes.string,
  videoSummary: PropTypes.string,
  transcript: PropTypes.shape(RichTextParserPropTypes),
  contentSections: PropTypes.array,
  wistiaVideo: PropTypes.object,
  nextSlug: PropTypes.string
};

function PageVideo({
  _id,
  _contentTypeId,
  pageTitle,
  video,
  videoTitle = null,
  videoSummary = null,
  transcript = null,
  contentSections = [],
  wistiaVideo = {},
  nextSlug = null,
  videoCardImage,
  breadcrumbs,
  subjects,
  tags,
  IndexedVideosOnly,
  videos
}) {

  let it;
  if (video) {
    const { description } = video
    if (typeof description === "object") {
      ({ it } = description)
    }
    else {
      it = ""
    }
  }
  const [isOpen, setOpen] = React.useState(false);
  const [wistiaTitle, setWistiaTitle] = React.useState('');
  const [wistiaDescription, setWistiaDescription] = React.useState('');
  const toggleClass = () => setOpen(!isOpen);
  const [storedVideos, setStoredVideos] = useState([])
  const [recheckstiredValues, setrecheckStoredValues] = useState(0)
  const [activeId, setActiveId] = useState(_id);
  const { t } = useTranslation();
  const router = useRouter();
  const subjectsData = subjects ? subjects.split(",") : []
  let filterSelectedVideo = []
  React.useEffect(() => {
    if (!videoTitle) {
      setWistiaTitle(wistiaVideo.video?.name);
    }
    if (!videoSummary) {
      setWistiaDescription(wistiaVideo.video?.description.replace(/(<([^>]+)>)/gi, ''));
    }

  }, [videoTitle, videoSummary, wistiaVideo]);
  if (tags && tags.length > 0) {
    const filtersubcategory = IndexedVideosOnly.filter((video, index) => {
      return video?.tags && video?.tags.some(tag => tags.includes(tag))
    })
    filterSelectedVideo = filtersubcategory.filter((ele, index) => {
      return ele._id !== _id
    })

    if (filterSelectedVideo.length === 0 && subjectsData.length > 0) {
      filterSelectedVideo = IndexedVideosOnly.filter((video, index) =>
        video?.subjects && subjectsData.includes(video?.subjects)
      ).filter(ele => ele._id !== _id)

    }

  }
  else if (subjectsData && subjectsData.length > 0) {
    const filtercategory = IndexedVideosOnly.filter((video, index) => {
      return video?.subjects && subjectsData.includes(video?.subjects)
    })

    filterSelectedVideo = filtercategory.filter((ele, index) => {
      return ele._id !== _id
    })
  }

  useEffect(() => {
    // Update meta
    const existing = document.querySelector('meta[name="wistia-embed-url"]');
    if (existing) {
      existing.remove();
    }
    const meta = document.createElement("meta");
    meta.name = "wistia-embed-url";
    meta.content = "https:" + videoCardImage.url;
    document.head.appendChild(meta);

  }, [activeId, videoCardImage]);
  const handleClick = (clickedId) => {
    setActiveId(clickedId); // set clicked ID
  };

  const slug = "video-library"
  return (
    <div className={styles.mainWrap}>
      <div className={styles.Buttons}>
        <Link href="/video-library">
          <span className={styles.allVideosButton}><span className={styles.chevronRIght}></span><span className={styles.text}>{t('common:allvidoes')}</span></span>
        </Link>
      </div>
      <section
        key="PageVideo"
        data-testid="PageVideo"
        className={styles.pageContent}
        {...sidekick(_id, null, _contentTypeId, 'Page Video')}>
        <Head>
          {/* eslint-disable-next-line react/no-danger */}
        </Head>

        {video ? (
          <div className={styles.video} data-testid="PageVideo-video">
            <ElementVideo {...video} />
          </div>
        ) : null}


        <h1 data-testid="PageVideo-pageTitle" className={styles.pageTitle} itemProp="name">
          {pageTitle}
        </h1>

        {transcript?.content && transcript?.content.length > 0 ? (
          <div className={styles.transcript} itemProp="transcript">
            <span className={styles.transcripttext}>{t('common:transcript')}</span>
            {video?.title || wistiaTitle ? (
              <h2 data-testid="PageVideo-videoTitle" className={styles.videoTitle} itemProp="name">
                {typeof video?.title === "object" ? Object.keys(video?.title).includes(router?.locale) ? video?.tile[router?.locale] : "" :
                  video?.title ?? wistiaTitle}
              </h2>
            ) : null}            <div className={cx(styles.transcriptWrap, styles.open)} data-testid="PageVideo-transcript">
              <RichTextParser document={transcript} _contentTypeId={_contentTypeId} />
            </div>
            {/* {filteredArray&& filteredArray.length>0 || entriBlock && entriBlock.length>0 ? */}
          </div>
        ) : null}


      </section>
      {filterSelectedVideo && filterSelectedVideo.length > 0 &&
        <div className={styles.moreVideosContainer}>
          <h2>{t('common:moreTutorials')}</h2>
          <div className={styles.cards}>
            {
              filterSelectedVideo.slice(0, 3).map((video, index) => (
                <VideoCard
                  index={index}
                  key={video?._id}
                  _id={video?._id}
                  headerText={video?.videoTitle}
                  summaryText={video?.videoSummary}
                  image={video?.videoCardImage}
                  tags={video?.tags}
                  subjects={video?.subjects}
                  slug={`/${slug}/${video?.slug}`}
                  className={styles.videoCard}
                  onClick={() => handleClick(video?._id)}
                />
              ))
            }
          </div>

        </div>
      }

    </div>
  );
}

PageVideo.propTypes = PageVideoPropTypes;

export default PageVideo;